import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ColorForm from "./ColorForm";
import { addColor } from "../../../api/colorService";

export default function AddColor() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);

      const res = await addColor(formData);
      setMessage(res.message)
      // backend validation
      if (res?.status === 422 || res?.success === false) {
        return res;
      }

      navigate("/color");
      return res;

    } catch (error) {
    
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="card p-4">
        <h4>Add Color</h4>
        {message && (
          <div
            className={`alert ${
              message.toLowerCase().includes("success")
                ? "alert-danger"
                : "alert-success"
            }`}
          >
            {message}
          </div>
        )}
        <ColorForm
          onSubmit={handleSubmit}
          loading={loading}
          buttonText="Add Color"
        />
      </div>
    </div>
  );
}
